import React, { useEffect, useRef, useState }  from 'react'
import ReactHlsPlayer from 'react-hls-player'

const CustomVideoPlayer = ({ src, horses, overlayUrl }) => {
  const [raceOrder, setRaceOrder] = useState([])
  const [fadeOutSilks, setFadeOutSilks] = useState(false)
  const [fadeInSilks, setFadeInSilks] = useState(false)
  const [loading, setLoading] = useState(true)
  const [raceTimes, setRaceTimes] = useState(null)

  const playerRef = useRef()
  const startTime = 27.00
  const endTime = 119.00

  const updateSilks = (currentTime, times) => {
    const raceTime = (currentTime - (startTime)).toFixed(2)

    if(!fadeInSilks && raceTime > 4) {
      setFadeInSilks(true)
    }

    const raceOrderUpdate = times
      .sort((a, b) => b.R - a.R)
      .find(r => r.R < raceTime)

    if(raceOrderUpdate) {
      setRaceOrder(raceOrderUpdate.O)
    }

    if(!fadeOutSilks && currentTime > endTime - 4) {
      setFadeOutSilks(true)
    }
  }

  useEffect(() => {
    async function getOverlayData() {
      try {
        const res = await fetch(overlayUrl)
        const data = await res.json()
        setLoading(false)
        playerRef.current.addEventListener('timeupdate', function (event) {
          updateSilks(this.currentTime, data)
        })
      }
      catch (ex) {
        setLoading(false)
      }
    }
    getOverlayData()
  }, []);

  const silkBarClass = () => {
    if(fadeOutSilks) {
      return 'fade-out'
    }
    if(fadeInSilks) {
      return 'fade-in'
    }
  }

  return loading ? <div>loading</div> : <div>
    <ReactHlsPlayer
      playerRef={playerRef}
      crossOrigin="anonymous"
      src={src}
      autoPlay={false}
      controls={true}
      width="100%"
      height="auto"
    />
    <div className={`silk-bar ${silkBarClass()}`}>
    { raceOrder.length > 0 ?
      <ul className="columns is-mobile">
      { raceOrder.map(silk => {
        const horse = horses.find(h => h.number == silk)
        return <li className="column silk-position">
            <div>
              <img alt={`${horse.name} silk`} src={horse.colorUrl} />
              <h1 className="has-text-centered">{ horse.name }</h1>
            </div>
          </li>
      })}
      </ul> : null }
    </div> 
    <style jsx>{`
      .silk-bar {
        min-height: 100px;
        opacity: 0;
      }
      .fade-in {
        opacity: 1;
        transition: opacity 2s linear;
      }
      .fade-out {
        opacity: 0;
        transition: opacity 2s linear;
      }
      @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
      }
      .silk-position {
        width: 8%;
        justify-content: center;
      }
      .silk-position h1 {
        font-weight:bold;
        font-size: 0.8em;
        white-space: nowrap;
          overflow: hidden;
            text-overflow: ellipsis;
      }
    `}</style>
  </div>
}

export default CustomVideoPlayer
